import { ref } from 'vue'
export const apiDialogVisible = ref<boolean>(false)
/*eslint-disable */
export const termsDialogInfo =  ``
export const privaryDialogInfo = '<div data-custom-class="body">23</div>'
